import { BehaviorSubject, Subject } from 'rxjs';

export interface FilterFormValue {
  withFollowUp: boolean;
  dueDate: {
    fromDateDue: any;
    toDateDue: any;
  };
  createdDate: {
    fromDateCreated: any;
    toDateCreated: any;
  };
  user: any;
  entity: any;
  team: any[];
  template: any;
  tag: any;
  priority: string;
  status: string;
  office: any;
}

export class TaskFilterService {
  initialFormValue = {
    withFollowUp: false,
    dueDate: { fromDateDue: null, toDateDue: null },
    createdDate: { fromDateCreated: null, toDateCreated: null },
    user: null,
    entity: null,
    team: [],
    template: null,
    tag: null,
    priority: '',
    status: '',
    office: null,
  };
  filterFormSubject = new BehaviorSubject<FilterFormValue>(this.initialFormValue);
  myTasks = new BehaviorSubject<boolean>(false);
  filteredEmitter = new BehaviorSubject<boolean>(false);
  isDefaultFilteredValue = new Subject<boolean>();
  activeFilter = new BehaviorSubject<any>({
    label: 'All',
    value: '',
    color: 'btn-text-dark btn-hover-bg-secondary',
  });
  filterCounter = new BehaviorSubject<number>(0);
  fromDashboard = new BehaviorSubject<boolean>(false);
  backFromGroupByView = new BehaviorSubject<boolean>(false);

  updateMyTaskStatus(status: boolean) {
    this.myTasks.next(status);
  }
  updateFilterObject(newFilterValue: FilterFormValue) {
    this.filterFormSubject.next(newFilterValue);
    let count = 0;
    for (const val in newFilterValue) {
      const newValue = newFilterValue[val];
      if (newValue) {
        if (typeof newValue !== 'object') {
          count++;
        } else if (typeof newValue === 'object') {
          if (val === 'dueDate' || val === 'createdDate') {
            for (const vals in newValue) {
              if (newValue[vals] !== null) {
                count++;
              }
            }
          } else if (Array.isArray(newValue) && newValue.length > 0) {
            count++;
          } else if (!Array.isArray(newValue) && newValue !== this.initialFormValue[val]) {
            count++;
          }
        }
      }
    }
    this.filterCounter.next(count);
    const valuesChanged = JSON.stringify(newFilterValue) !== JSON.stringify(this.initialFormValue);
    valuesChanged ? this.filteredEmitter.next(true) : this.filteredEmitter.next(false);
  }
}
